/* ===========================================================
   PARAMPORA theme.js
   =========================================================== */
(function(){
  'use strict';
  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const money=(c)=>{
    try{return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(c,window.PP_MONEY):'₹'+(c/100).toLocaleString('en-IN');}
    catch(e){return '₹'+(c/100).toLocaleString('en-IN');}
  };

  /* ---------- drawers (cart + mobile nav + filters) ---------- */
  const scrim=$('#scrim');
  function openPanel(el){el&&el.classList.add('open');scrim&&scrim.classList.add('show');document.body.style.overflow='hidden';}
  function closeAll(){$$('.drawer,.mobile-nav,.facets').forEach(d=>d.classList.remove('open'));scrim&&scrim.classList.remove('show');document.body.style.overflow='';}
  scrim&&scrim.addEventListener('click',closeAll);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll();});
  $$('[data-open-cart]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openPanel($('#cart-drawer'));refreshCart();}));
  $('#burger')&&$('#burger').addEventListener('click',()=>openPanel($('#mobile-nav')));
  $('#filter-toggle')&&$('#filter-toggle').addEventListener('click',()=>openPanel($('.facets')));
  $$('[data-close]').forEach(b=>b.addEventListener('click',closeAll));

  /* ---------- mobile search dropdown ---------- */
  const searchToggle=$('#mobile-search-toggle');
  const searchDrop=$('#mobile-search-drop');
  const searchClose=$('#mobile-search-close');
  const searchInput=$('#mobile-search-input');
  function openSearch(){searchDrop&&searchDrop.classList.add('open');searchToggle&&searchToggle.setAttribute('aria-expanded','true');setTimeout(()=>searchInput&&searchInput.focus(),300);}
  function closeSearch(){searchDrop&&searchDrop.classList.remove('open');searchToggle&&searchToggle.setAttribute('aria-expanded','false');}
  searchToggle&&searchToggle.addEventListener('click',()=>{
    (searchDrop&&searchDrop.classList.contains('open'))?closeSearch():openSearch();
  });
  searchClose&&searchClose.addEventListener('click',closeSearch);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeSearch();});

  /* ---------- hover-to-play product video ---------- */
  function bindCardVideos(scope=document){
    $$('.card',scope).forEach(card=>{
      const v=$('.card__video',card);
      if(!v)return;
      let started=false;
      const play=()=>{ if(window.matchMedia('(hover:none)').matches)return;
        card.classList.add('is-playing');
        if(!started){ if(v.dataset.src&&!v.src){v.src=v.dataset.src;} started=true; }
        const p=v.play(); if(p&&p.catch)p.catch(()=>{});
      };
      const stop=()=>{ card.classList.remove('is-playing'); try{v.pause();v.currentTime=0;}catch(e){} };
      card.addEventListener('mouseenter',play);
      card.addEventListener('mouseleave',stop);
    });
  }
  bindCardVideos();

  /* ---------- reveal on scroll ---------- */
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    $$('.reveal').forEach(el=>io.observe(el));
  }else{$$('.reveal').forEach(el=>el.classList.add('in'));}

  /* ---------- ajax add to cart ---------- */
  async function addToCart(form,btn){
    const data=new FormData(form);
    const original=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.innerHTML='<span>Adding…</span>';}
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:data});
      if(!r.ok){const err=await r.json();throw new Error(err.description||'Could not add');}
      await refreshCart();
      openPanel($('#cart-drawer'));
      if(btn){btn.innerHTML='<span>Added ✓</span>';setTimeout(()=>{btn.innerHTML=original;btn.disabled=false;},1200);}
    }catch(e){
      if(btn){btn.innerHTML='<span>'+(e.message||'Unavailable')+'</span>';setTimeout(()=>{btn.innerHTML=original;btn.disabled=false;},1800);}
    }
  }
  $$('form[action$="/cart/add"]').forEach(f=>{
    f.addEventListener('submit',e=>{e.preventDefault();addToCart(f,$('[type="submit"]',f));});
  });

  /* ---------- render cart drawer ---------- */
  async function refreshCart(){
    const wrap=$('#cart-drawer');if(!wrap)return;
    try{
      const cart=await(await fetch('/cart.js',{headers:{'Accept':'application/json'}})).json();
      $$('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.classList.toggle('hide',cart.item_count===0);});
      const items=$('#cart-items'),foot=$('#cart-foot'),promo=$('.drawer__promo');
      if(cart.item_count===0){
        if(promo) promo.style.display='none';
        items.innerHTML='<div class="drawer__empty"><p class="lede">Your cart is empty</p><p class="muted">Discover handwoven heirlooms waiting to be yours.</p><a class="btn btn--ghost btn--sm mt-m" href="/collections/all"><span>Explore Sarees</span></a></div>';
        foot.innerHTML='';return;
      }
      if(promo) promo.style.display='flex';
      items.innerHTML=cart.items.map(it=>`
        <div class="line" data-key="${it.key}">
          <a href="${it.url}"><img src="${it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):''}" alt="${it.product_title}"></a>
          <div>
            <a href="${it.url}" class="line__title">${it.product_title}</a>
            <div class="line__meta">${it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:''}</div>
            <div class="qty" style="margin-top:8px">
              <button data-step="-1" data-key="${it.key}" aria-label="Decrease">−</button>
              <input value="${it.quantity}" readonly>
              <button data-step="1" data-key="${it.key}" aria-label="Increase">+</button>
            </div>
          </div>
          <div style="text-align:right">
            <div class="price">${money(it.final_line_price)}</div>
            <button class="link-underline" style="margin-top:10px;font-size:.66rem" data-remove="${it.key}">Remove</button>
          </div>
        </div>`).join('');
      foot.innerHTML=`
        <div class="drawer__total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
        <p class="drawer__note">Shipping, taxes, and discount codes calculated at checkout.</p>
        <a href="/checkout" class="btn btn--block"><span>Proceed to Checkout</span></a>
        <a href="/cart" class="link-underline" style="display:block;text-align:center;margin-top:14px">View Cart</a>`;
      bindLineEvents();
    }catch(e){/* silent */}
  }
  function bindLineEvents(){
    $$('[data-step]').forEach(b=>b.addEventListener('click',()=>{
      b.disabled=true;
      changeQty(b.dataset.key,parseInt(b.dataset.step,10));
    }));
    $$('[data-remove]').forEach(b=>b.addEventListener('click',()=>setQty(b.dataset.remove,0)));
  }
  function changeQty(key,step){
    const input=document.querySelector(`.line[data-key="${key}"] input`);
    if(!input)return;
    const current=parseInt(input.value,10)||1;
    setQty(key,Math.max(0,current+step));
  }
  async function setQty(key,q){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:q})});
    refreshCart();
  }
  refreshCart();

  /* ---------- PDP gallery ---------- */
  $$('[data-gallery]').forEach(g=>{
    const main=$('[data-main]',g);
    $$('[data-thumb]',g).forEach(t=>{
      t.addEventListener('click',()=>{
        $$('[data-thumb]',g).forEach(x=>x.classList.remove('active'));t.classList.add('active');
        const type=t.dataset.type,src=t.dataset.full;
        main.innerHTML = type==='video'
          ? `<video src="${src}" autoplay muted loop playsinline></video>`
          : `<img src="${src}" alt="">`;
      });
    });
  });

  /* ---------- PDP quantity ---------- */
  $$('[data-qty]').forEach(q=>{
    const inp=$('input',q);
    $$('button',q).forEach(b=>b.addEventListener('click',()=>{
      let v=parseInt(inp.value,10)||1;v+=parseInt(b.dataset.q,10);inp.value=Math.max(1,v);
    }));
  });

  /* ---------- variant swatches ---------- */
  $$('[data-variants]').forEach(root=>{
    const idInput=$('[name="id"]',root.closest('form'));
    $$('[data-variant]',root).forEach(s=>{
      s.addEventListener('click',()=>{
        $$('[data-variant]',root).forEach(x=>x.setAttribute('aria-checked','false'));
        s.setAttribute('aria-checked','true');
        if(idInput)idInput.value=s.dataset.variant;
      });
    });
  });

  /* ---------- collection sort ---------- */
  $('#sort-by')&&$('#sort-by').addEventListener('change',function(){
    const u=new URL(window.location.href);u.searchParams.set('sort_by',this.value);u.searchParams.delete('page');window.location.href=u.toString();
  });

  /* ---------- countdown (coming soon) ---------- */
  const cd=$('[data-countdown]');
  if(cd){
    const target=new Date(cd.dataset.countdown).getTime();
    const tick=()=>{
      const d=target-Date.now();
      if(d<=0){cd.innerHTML='<p class="lede">We are live ✦</p>';return;}
      const day=Math.floor(d/86400000),h=Math.floor(d%86400000/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      const set=(k,v)=>{const el=cd.querySelector('[data-'+k+']');if(el)el.textContent=String(v).padStart(2,'0');};
      set('d',day);set('h',h);set('m',m);set('s',s);
    };
    tick();setInterval(tick,1000);
  }

  document.addEventListener('shopify:section:load',()=>{bindCardVideos();bindWishlist();});

    /* ---------- wishlist (localStorage-based) ---------- */
  const WISH_KEY='parampora_wishlist';
  function getWishlist(){ try{return JSON.parse(localStorage.getItem(WISH_KEY))||[];}catch(e){return [];} }
  function saveWishlist(list){ try{localStorage.setItem(WISH_KEY,JSON.stringify(list));}catch(e){} }
  function isWished(id){ return getWishlist().some(p=>String(p.id)===String(id)); }
  function updateWishCount(){
    const n=getWishlist().length;
    $$('[data-wishlist-count]').forEach(el=>{el.textContent=n;el.classList.toggle('hide',n===0);});
  }
  function syncWishButtons(scope=document){
    $$('[data-wishlist-toggle]',scope).forEach(btn=>{
      btn.setAttribute('aria-pressed', isWished(btn.dataset.id) ? 'true' : 'false');
    });
  }
  function bindWishlist(scope=document){
    $$('[data-wishlist-toggle]',scope).forEach(btn=>{
      if(btn.dataset.bound)return; btn.dataset.bound='1';
      btn.addEventListener('click',e=>{
        e.preventDefault(); e.stopPropagation();
        const id=btn.dataset.id;
        let list=getWishlist();
        if(isWished(id)){
          list=list.filter(p=>String(p.id)!==String(id));
        }else{
          list.push({
            id:id,
            variantId:btn.dataset.variant||'',
            title:btn.dataset.title,
            url:btn.dataset.url,
            image:btn.dataset.image,
            price:btn.dataset.price
          });
          btn.classList.add('wish-pop');
          setTimeout(()=>btn.classList.remove('wish-pop'),450);
        }
        saveWishlist(list);
        syncWishButtons();
        updateWishCount();
        renderWishlistPage();
      });
    });
  }
  async function quickAddToCart(variantId,btn){
    if(!variantId){ if(btn){btn.textContent='Unavailable';setTimeout(()=>btn.textContent='Add to Cart',1500);} return; }
    const original=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    try{
      const r=await fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:variantId,quantity:1}]})
      });
      if(!r.ok){const err=await r.json();throw new Error(err.description||'Could not add');}
      await refreshCart();
      openPanel($('#cart-drawer'));
      if(btn){btn.textContent='Added ✓';setTimeout(()=>{btn.textContent=original;btn.disabled=false;},1300);}
    }catch(e){
      if(btn){btn.textContent='Sold Out';setTimeout(()=>{btn.textContent=original;btn.disabled=false;},1500);}
    }
  }
  function bindQuickAdd(scope=document){
    $$('[data-wish-add]',scope).forEach(btn=>{
      if(btn.dataset.bound)return; btn.dataset.bound='1';
      btn.addEventListener('click',e=>{
        e.preventDefault();
        quickAddToCart(btn.dataset.variant,btn);
      });
    });
  }
  function renderWishlistPage(){
    const grid=$('[data-wishlist-grid]'); if(!grid) return;
    const list=getWishlist();
    if(list.length===0){
      grid.innerHTML='';
      const empty=$('[data-wishlist-empty]'); if(empty) empty.classList.remove('hide');
      return;
    }
    const empty=$('[data-wishlist-empty]'); if(empty) empty.classList.add('hide');
    grid.innerHTML=list.map(p=>`
      <article class="card">
        <a class="card__media" href="${p.url}"><img src="${p.image}" alt="${p.title}" loading="lazy"></a>
        <button type="button" class="card__wish" aria-pressed="true" data-wishlist-toggle
          data-id="${p.id}" data-title="${p.title}" data-url="${p.url}" data-image="${p.image}" data-price="${p.price}" data-variant="${p.variantId||''}">
          ${$('#wish-icon-tpl')?$('#wish-icon-tpl').innerHTML:'♥'}
        </button>
        <div class="card__body">
          <h3 class="card__title"><a href="${p.url}">${p.title}</a></h3>
          <div style="margin-top:6px"><span class="price">${money(p.price)}</span></div>
          <button type="button" class="btn btn--gold btn--sm btn--block mt-s" data-wish-add data-variant="${p.variantId||''}">
            <span>Add to Cart</span>
          </button>
        </div>
      </article>`).join('');
    bindWishlist(grid);
    bindQuickAdd(grid);
  }
  bindWishlist();
  syncWishButtons();
  updateWishCount();
  renderWishlistPage();

  /* ---------- chat widget ---------- */
  const chatWidget=$('#chat-widget');
  const chatToggle=$('#chat-widget-toggle');
  const chatPanel=$('#chat-panel');
  const chatClose=$('#chat-panel-close');
  if(chatWidget&&chatToggle){
    chatToggle.addEventListener('click',()=>{
      chatWidget.classList.toggle('open');
      chatPanel.setAttribute('aria-hidden', chatWidget.classList.contains('open')?'false':'true');
    });
  }
  if(chatClose){
    chatClose.addEventListener('click',()=>{
      chatWidget.classList.remove('open');
      chatPanel.setAttribute('aria-hidden','true');
    });
  }
  document.addEventListener('click',(e)=>{
    if(chatWidget&&chatWidget.classList.contains('open')&&!chatWidget.contains(e.target)){
      chatWidget.classList.remove('open');
    }
  });
})();